var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatTopBarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 4,
    fill: "#64748B"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1876_9217)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 15.3333L17.9998 13.3333H13.3332C13.1564 13.3333 12.9868 13.2631 12.8618 13.1381C12.7367 13.013 12.6665 12.8435 12.6665 12.6667V8.66667C12.6665 8.48986 12.7367 8.32029 12.8618 8.19526C12.9868 8.07024 13.1564 8 13.3332 8H19.3332C19.51 8 19.6796 8.07024 19.8046 8.19526C19.9296 8.32029 19.9998 8.48986 19.9998 8.66667V15.3333Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3333 16.0001V17.3334C15.3333 17.5102 15.2631 17.6798 15.1381 17.8048C15.013 17.9298 14.8435 18.0001 14.6667 18.0001H10L8 20.0001V13.3334C8 13.1566 8.07024 12.987 8.19526 12.862C8.32029 12.737 8.48986 12.6667 8.66667 12.6667H10",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1876_9217"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatTopBarIcon);
export default __webpack_public_path__ + "static/media/chat_top_bar_icon.3a0789d4d216f148bd71871ca30a2113.svg";
export { ForwardRef as ReactComponent };